module.exports = __webpack_public_path__ + "static/media/Peru.e6ef064a.png";